<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">Баҳолаш ва изоҳ
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.ochiq_malumot')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>

          <section class="section py-3">
            <div class="container">
              <div style="display:flex; align-items: center; gap: 10px; margin-bottom: 10px" v-if="$i18n.locale === 'ru-RU'">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane v-for="item in openCardTabs" :label="item.titleRu" :name="item.id.toString()"></el-tab-pane>
                </el-tabs>
              </div>
              <div style="display:flex; align-items: center; gap: 10px; margin-bottom: 10px" v-else-if="$i18n.locale === 'uz-UZ'">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane v-for="item in openCardTabs" :label="item.titleUz" :name="item.id.toString()"></el-tab-pane>
                </el-tabs>
              </div>
              <div style="display:flex; align-items: center; gap: 10px; margin-bottom: 10px" v-else-if="$i18n.locale === 'uz-QR'">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane v-for="item in openCardTabs" :label="uzQr(item, 'titleUzQr', 'titleUz')" :name="item.id.toString()"></el-tab-pane>
                </el-tabs>
              </div>
              <div style="display:flex; align-items: center; gap: 10px; margin-bottom: 10px" v-else-if="$i18n.locale === 'uz-CYR'">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane v-for="item in openCardTabs" :label="item.titleUzCyr" :name="item.id.toString()"></el-tab-pane>
                </el-tabs>
              </div>
              <div style="display:flex; align-items: center; gap: 10px; margin-bottom: 10px" v-else-if="$i18n.locale === 'en-US'">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane v-for="item in openCardTabs" :label="item.titleUz" :name="item.id.toString()"></el-tab-pane>
                </el-tabs>
              </div>



              <el-dialog
                  :title="$t('openCardScore.title')"
                  :visible.sync="dialogVisible"
                  width="30%"
                  :before-close="handleClose"
              >
                <div style="display:flex; flex-direction: column; width: 100%;">
                  <label>
                    <span>{{ $t('openCardScore.score') }}</span>
                    <el-rate
                        v-model="openCardScore.score"
                        :colors="colors"
                        show-score
                        text-color="#ff9900">
                    </el-rate>
                  </label>
                  <label>
                    <span>{{ $t('openCardScore.description') }}</span>
                    <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="Илтимос киритинг"
                        v-model="openCardScore.description">
                    </el-input>
                  </label>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button
                      size="mini"
                      @click="dialogVisible = false"
                  >
                    {{ $t('openCardScore.close') }}
                  </el-button>
                  <el-button
                      size="mini"
                      type="primary"
                      @click="openDataScorePost"
                  >
                    {{ $t('openCardScore.confirm') }}
                  </el-button>
                </span>
              </el-dialog>




              <div v-if="activeName === '6'">
                <el-table
                    :data="apostl"
                    border
                    style="width: 100%">
                  <el-table-column
                      prop="date"
                      label="№"
                      width="50">
                  </el-table-column>
                  <el-table-column
                      prop="name"
                      :label="$t('apostl.vaqti')"
                      width="180">
                  </el-table-column>
                  <el-table-column
                      prop="name"
                      :label="$t('apostl.ijrochi')">
                  </el-table-column>
                  <el-table-column
                      prop="name"
                      :label="$t('apostl.holati')"
                      width="180">
                  </el-table-column>
                  <el-table-column
                      prop="name"
                      :label="$t('apostl.natijasi')"
                      width="180">
                  </el-table-column>
                </el-table>
              </div>
              <el-row :gutter="15" v-if="activeName !== '6'">
                <el-col :sm="24" :md="24" :lg="24" class="mb-3 mb-lg-10" v-for="item in openResource" :key="item.id">
                  <div class="download_button">
                    <el-rate
                        class="open-card-rate"
                        v-model="item.rate"
                        text-color="#ff9900">
                    </el-rate>
                    <div
                        class="open-card-rate"
                        style="z-index: 20;
                        cursor: pointer;
                        background: transparent !important;
                        width: 132px;
                        height: 20px"
                        @click="openDialog(item)">
                    </div>
                    <a :href="'https://www.prokuratura.uz/api/download/' + item.fileTitle + (item.fileTypeSelected === 'word' ? '.docx' : item.fileTypeSelected === 'excel' ? '.xlsx' : '.pdf') "  target="_blank">
                      <div class="card card-lift shadow border-0 card-link_new">
                        <img style=" padding-right: 5px; border-right: 1px solid #0b2769" width="45" height="45" src="../../public/img/strategy/word.png" alt="word" v-if="item.fileTypeSelected === 'word'">
                        <img style=" padding-right: 5px; border-right: 1px solid #0b2769" width="45" height="45" src="../../public/img/strategy/excel.svg" alt="word" v-else-if="item.fileTypeSelected === 'excel'">
                        <img style=" padding-right: 5px; border-right: 1px solid #0b2769" width="45" height="45" src="../../public/img/strategy/pdf_file.svg" alt="word" v-else>
                        <span v-if="$i18n.locale === 'uz-UZ'" class="card_span_link vertical-center">{{item.textUz}}</span>
                        <span v-if="$i18n.locale === 'uz-QR'" class="card_span_link vertical-center">{{uzQr(item, 'textUzQr', 'textUz')}}</span>
                        <span v-if="$i18n.locale === 'uz-CYR'" class="card_span_link vertical-center">{{item.textUzCyr}}</span>
                        <span v-if="$i18n.locale === 'ru-RU'" class="card_span_link vertical-center">{{item.textRu}}</span>
                        <span v-if="$i18n.locale === 'en-US'" class="card_span_link vertical-center">{{item.textUz}}</span>
                      </div>
                    </a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </section>
          <div style="text-align: center" v-if="activeName !== '6'">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="totalPage"
                layout="total, prev, pager, next"
                :total="total">
            </el-pagination>
          </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";

    export default {
        data() {
            return {
              openCardScore: {
                score: 5,
                openDataId: null,
                description: '',
              },
              colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
              dialogVisible: false,
              total: 0,
              activeName: '1',
              apostl: [],
              openResource: null,
              openCardTabs: [],
              categoryGetById: '1',
              currentPage: 1,
              totalPage: 1,
              page: 0
            };
        },
      methods: {
        openDataScorePost() {
          this.dialogVisible = false;
          axios
              .post(`https://www.prokuratura.uz/api/open-data-score`, this.openCardScore)
              .then(response => {
                this.openCardScore.score = 5;
                this.openCardScore.openDataId = null;
                this.openCardScore.description = '';
              })
        },

        openDialog(data) {

          this.dialogVisible = true;
          this.openCardScore.openDataId = data.id

        },
        handleSizeChange(val) {

        },

        handleClose() {
          this.dialogVisible = false
        },

        handleCurrentChange(val) {
          this.page = val - 1
          this.getOpenData()
        },
        getOpenData() {
          axios
              .get(`https://www.prokuratura.uz/api/open-data-for-web/?categoryId=${this.categoryGetById}&page=${this.page}`)
              .then(res => {
                console.log(res)
                this.openResource = res.data.content
                this.total = res.data.totalElements
                this.totalPage = res.data.size
              })
        },
        handleClick(tab) {
          console.log(this.activeName)
          this.categoryGetById = tab.name
          this.getOpenData()
        },
        uzQr(item, qrKey, fallbackKey) {
          return (item && item[qrKey]) || (item && item[fallbackKey]) || "";
        }
      },
      mounted() {
        this.getOpenData()

        axios
            .get(`https://www.prokuratura.uz/api/category-for-open-card-all-for-web`)
            .then(response => {
              this.openCardTabs = response.data
            })
      }
    }
</script>
<style scoped>

.download_button {
  position: relative;
}

.open-card-rate {
  padding: 5px;
  position: absolute;
  right: 10px;
  top: -10px;
  z-index: 10;
  border-radius: 50px;
  background: #96b4d3 !important;
  display: flex;
  align-items: center;
  border: 1px solid black;
}

.open_card-score {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  font-size: 30px;
  z-index: 10;
  cursor: pointer;
}

.card_span_link  {
  padding-right: 30px;
}

label {
  display: flex;
  flex-direction: column;
}

</style>
